import { Redirect } from "react-router-dom";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { CMP_PROFILE_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";

import ApplicationSubmitted from "../ApplicationSubmitted";
import Loading from "../Loading";
import StudentApplicationLoggedInForm from "./LoggedInForm";
import StudentApplicationLoggedOutForm from "./LoggedOutForm";

export default function StudentApplication() {
  const { patientProfile, practitionerProfile, user, loading } = useUserProfileContext();
  const { resolvedUrls } = useCmpRelatedUrl();

  if (practitionerProfile) {
    if (!practitionerProfile.approved) {
      if (practitionerProfile.currentPractitionerLevel) {
        return <ApplicationSubmitted entity="Student Practitioner partner" />;
      } else {
        // just in case an unapproved partner is visiting this student application page but in fact does not have a current practitioner level
        return <ApplicationSubmitted />;
      }
    }

    return <Redirect to={resolvedUrls[CMP_PROFILE_URL]} />;
  }

  if (user) {
    return <StudentApplicationLoggedInForm user={user} patientProfile={patientProfile} />;
  }

  if (!loading) return <StudentApplicationLoggedOutForm />;

  return <Loading />;
}
